import { Button, Grid, TextField } from "@mui/material";
import Title from "../generic/Title";
import { fieldLabel } from "./sections";
import { IReports } from "../../types/CommonTypes";
import Item from "./generic/ImageItem";
import { useEffect, useState } from "react";
import useFirebase from "../../commons/firebase/useFirebase";
import {
	getRandomId,
	getTweetIdByUrl,
	isTweetId,
} from "../../commons/constants/helpers";

interface IProps {
	item: IReports;
	onChange: any;
}

export default function DashboardReports({ item, onChange }: IProps) {
	const [data, setData] = useState<IReports>(item);
	const { uploadFileToStorage } = useFirebase();

	useEffect(() => {
		onChange && onChange(data);
	}, [data]);

	const handleNewPic = async (id: string, file: any) => {
		try {
			let path = "/assets/reports/";
			const downloadURL = await uploadFileToStorage(
				file,
				path + file.name
			);
			let updated: any = data.images.map((item) => {
				if (item.id === id) {
					return {
						id: id,
						name: getRandomId(),
						path: path,
						url: downloadURL,
					};
				}
				return item;
			});

			setData({ ...data, images: updated });
		} catch (error) {
			console.log("Error al cargar el archivo:", error);
		}
	};

	// Se identifica por posición y no por tweet.id: el id es justo el valor
	// que se está editando, así que dos filas con el mismo tuit (o dos vacías)
	// se pisaban entre sí y React renderizaba mal las tarjetas.
	const handleText = (index: number, value: string, field: string) => {
		let updated: any = data.tweets.map((tweet, i) =>
			i === index ? { ...tweet, [field]: value } : tweet
		);

		setData({ ...data, tweets: updated });
	};

	const handleAddNew = () => {
		setData({
			...data,
			tweets: [
				...data.tweets,
				{
					id: "",
				},
			],
		});
	};

	const deleteTweet = (index: number) => {
		let filtered = data.tweets.filter((item, i) => i !== index);
		setData({ ...data, tweets: filtered });
	};

	return (
		<Grid container>
			<Title>Imágenes</Title>
			{data.images.map((image) => (
				<Item
					key={image.id}
					label={fieldLabel("reports", image.id)}
					source={image.url}
					onUpdate={(file: any) => handleNewPic(image.id, file)}
				/>
			))}
			<Title>Tuits publicados</Title>
			{data.tweets.map((tweet, index) => (
				<Grid item md={5} key={index} style={{ margin: "20px" }}>
					<Title>{`Tuit ${index + 1}`}</Title>
					<TextField
						fullWidth
						value={tweet.id}
						label={"Enlace del tuit"}
						placeholder="https://x.com/danielbricen/status/1234567890"
						error={!!tweet.id && !isTweetId(tweet.id)}
						helperText={
							isTweetId(tweet.id)
								? `Enlazado al tuit ${tweet.id}`
								: "Pega el enlace del tuit: en X, botón Compartir → Copiar enlace."
						}
						onChange={(e) =>
							handleText(
								index,
								getTweetIdByUrl(e.target.value),
								"id"
							)
						}
						style={{ marginBottom: "10px" }}
					/>
					<Button
						onClick={() => deleteTweet(index)}
						fullWidth
						variant="contained"
						color="secondary"
					>
						Eliminar
					</Button>
				</Grid>
			))}
			<Button
				style={{ marginTop: "50px" }}
				onClick={handleAddNew}
				disabled={data.tweets.some((tweet) => !tweet.id)}
				fullWidth
				variant="contained"
			>
				Agregar otro tuit
			</Button>
		</Grid>
	);
}
